import React, { useState } from 'react';
import { AlertCircle, ArrowLeft, Eye, EyeOff, KeyRound, Lock, ShieldCheck, User } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../../components/ui/Dialog';
import { DMPLogo } from '../../components/brand/DMPLogo';
import { useDemo } from '../../contexts/DemoContext';
import { DEMO_PASSWORD, demoUsers, roleLabel, roles } from '../../data/roles';
import type { DemoUser } from '../../types/notice';
export function AdminLogin() {
  const {
    login
  } = useDemo();
  const navigate = useNavigate();
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [errors, setErrors] = useState<{
    userId?: string;
    password?: string;
    form?: string;
  }>({});
  const [pending, setPending] = useState<DemoUser | null>(null);
  const [otp, setOtp] = useState('');
  const [otpError, setOtpError] = useState('');
  const [forgotOpen, setForgotOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const next: typeof errors = {};
    if (!userId.trim()) next.userId = 'ইউজার আইডি প্রদান করুন';
    if (!password) next.password = 'পাসওয়ার্ড প্রদান করুন';else if (password.length < 6) next.password = 'পাসওয়ার্ড কমপক্ষে ৬ অক্ষরের হতে হবে';
    if (Object.keys(next).length) return setErrors(next);
    const u = demoUsers.find(d => d.userId === userId.trim());
    if (!u || password !== DEMO_PASSWORD) return setErrors({
      form: 'ইউজার আইডি অথবা পাসওয়ার্ড সঠিক নয়। পুনরায় চেষ্টা করুন।'
    });
    setErrors({});
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      const role = roles.find(r => r.id === u.role);
      if (role?.mfa) setPending(u);else finish(u);
    }, 600);
  };
  const finish = (u: DemoUser) => {
    login(u);
    toast.success(`স্বাগতম, ${u.name}`, {
      description: roleLabel(u.role)
    });
    navigate('/admin');
  };
  const verifyOtp = () => {
    if (!/^\d{6}$/.test(otp)) return setOtpError('৬ অঙ্কের OTP কোড প্রদান করুন');
    if (pending) finish(pending);
  };
  const fill = (u: DemoUser) => {
    setUserId(u.userId);
    setPassword(DEMO_PASSWORD);
    setErrors({});
  };
  return <div className="grid min-h-screen w-full bg-white lg:grid-cols-[1.05fr_1fr]" data-id="element-647" data-mp="47ue2uzuz8xf">
      <aside className="relative hidden flex-col justify-between bg-[#003B71] p-12 text-white lg:flex" data-id="element-648" data-mp="i6u529aufzwr">
        <div className="flex items-center gap-4" data-id="element-649" data-mp="d8ag000ye806">
          <DMPLogo size={72} data-id="element-650" data-mp="d6fy6ukzaw0b" />
          <div data-id="element-651" data-mp="1tmadz5g8nnks">
            <div className="text-sm text-white/70" data-id="element-652" data-mp="1tm0qboio1si9">গণপ্রজাতন্ত্রী বাংলাদেশ সরকার</div>
            <div className="text-2xl font-bold" data-id="element-653" data-mp="1on65kh151tvi">ঢাকা মেট্রোপলিটন পুলিশ</div>
            <div className="text-sm text-white/70" data-id="element-654" data-mp="1opa92xv4kqv9">ট্রাফিক বিভাগ</div>
          </div>
        </div>
        <div data-id="element-655" data-mp="36mx3p71armw8">
          <h2 className="text-3xl font-bold leading-snug" data-id="element-656" data-mp="36n5f0uhruk5b">এআই ট্রাফিক প্রসিকিউশন নোটিশ যাচাই ও ভেরিফিকেশন প্ল্যাটফর্ম</h2>
          <ul className="mt-6 space-y-3 text-[15px] text-white/85" data-id="element-657" data-mp="2xknv4mpla3lh">
            {['AI/OCR ভিত্তিক নোটিশ ডিজিটাইজেশন', 'মেকার-চেকার যাচাই ও অনুমোদন', 'QR সম্বলিত নিরাপদ নোটিশ', 'নাগরিক যাচাই ও প্রতারণা প্রতিরোধ'].map(t => <li key={t} className="flex items-center gap-3" data-id="element-658" data-mp="3qa35rbdcdugv">
                <ShieldCheck className="h-5 w-5 text-[#7fd1b0]" data-id="element-659" data-mp="3ua587mqwirx7" /> {t}
              </li>)}
          </ul>
        </div>
        <div className="text-xs text-white/50" data-id="element-660" data-mp="3ghxhabmatv6f">শুধুমাত্র অনুমোদিত ডিএমপি কর্মকর্তাদের জন্য • সকল কার্যক্রম অডিট লগে সংরক্ষিত</div>
        <div className="absolute bottom-0 left-0 right-0 h-1.5 bg-[#006A4E]" data-id="element-661" data-mp="3lg8ringia7p6" />
      </aside>

      <main className="flex flex-col justify-center px-6 py-10 sm:px-12" data-id="element-662" data-mp="d0yrdkw6fck1">
        <div className="mx-auto w-full max-w-md" data-id="element-663" data-mp="hu1lbu4v8o0r">
          <Link to="/" className="mb-6 inline-flex items-center gap-1 text-sm text-slate-500 hover:text-[#003B71]" data-id="element-664" data-mp="hut4u6l6uvao">
            <ArrowLeft className="h-4 w-4" data-id="element-665" data-mp="2kdq9ygup4ytl" /> প্রোটোটাইপ হাব
          </Link>
          <div className="mb-6 flex flex-col items-center text-center" data-id="element-666" data-mp="2kftb9x1auedm">
            <DMPLogo size={76} data-id="element-667" data-mp="2gcercva8pduw" />
            <h1 className="mt-3 text-[22px] font-bold text-[#003B71]" data-id="element-668" data-mp="2bcs4rv8iul9f">ডিএমপি ট্রাফিক প্রসিকিউশন যাচাই ব্যবস্থা</h1>
            <p className="text-sm text-slate-500" data-id="element-669" data-mp="382t1qhj1o81t">ঢাকা মেট্রোপলিটন পুলিশ</p>
          </div>

          {!pending ? <form onSubmit={submit} noValidate className="space-y-4" data-id="element-670" data-mp="3417i8dc08vin">
              {errors.form && <div role="alert" className="flex items-start gap-2 rounded-md border border-[#D93036]/30 bg-[#FCE9EA] p-3 text-sm text-[#B4232A]" data-id="element-671" data-mp="2z9pgvo62ksx5">
                  <AlertCircle className="mt-0.5 h-4 w-4 shrink-0" data-id="element-672" data-mp="2u9tn0hr36hvb" /> {errors.form}
                </div>}
              <div data-id="element-673" data-mp="3n0lgv8koiufh">
                <label htmlFor="uid" className="mb-1.5 block text-sm font-medium" data-id="element-674" data-mp="3n01vfhvtlnwp">ইউজার আইডি</label>
                <div className="relative" data-id="element-675" data-mp="3uc9ls4bbglh0">
                  <User className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-676" data-mp="3udknzzp45l60" />
                  <Input id="uid" value={userId} onChange={e => setUserId(e.target.value)} placeholder="যেমন: dmp.kamrul" className="h-11 pl-9" aria-invalid={!!errors.userId} data-id="element-677" data-mp="379hho1c3s7a" />
                </div>
                {errors.userId && <p className="mt-1 text-xs text-[#D93036]" data-id="element-678" data-mp="h4y34y3873de">{errors.userId}</p>}
              </div>
              <div data-id="element-679" data-mp="m418kjn4bblw">
                <div className="mb-1.5 flex items-center justify-between" data-id="element-680" data-mp="m3hooxdwqd58">
                  <label htmlFor="pw" className="text-sm font-medium" data-id="element-681" data-mp="qurdjvrmtcg2">পাসওয়ার্ড</label>
                  <button type="button" onClick={() => setForgotOpen(true)} className="text-xs font-medium text-[#1769AA] hover:underline" data-id="element-682" data-mp="qwuaz0v467ut">পাসওয়ার্ড ভুলে গেছেন?</button>
                </div>
                <div className="relative" data-id="element-683" data-mp="ztcslgxwa9c3">
                  <Lock className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-684" data-mp="14tzgmzqx14pj" />
                  <Input id="pw" type={showPw ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" className="h-11 pl-9 pr-10" aria-invalid={!!errors.password} data-id="element-685" data-mp="30x5ghxs05ynq" />
                  <button type="button" onClick={() => setShowPw(s => !s)} className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-500" aria-label={showPw ? 'পাসওয়ার্ড লুকান' : 'পাসওয়ার্ড দেখুন'} data-id="element-686" data-mp="3aoi94rlmksut">
                    {showPw ? <EyeOff className="h-4 w-4" data-id="element-687" data-mp="3kk3acnivdp3i" /> : <Eye className="h-4 w-4" data-id="element-688" data-mp="3fmjvblecl8ai" />}
                  </button>
                </div>
                {errors.password && <p className="mt-1 text-xs text-[#D93036]" data-id="element-689" data-mp="3tm2sxk9j918k">{errors.password}</p>}
              </div>
              <Button type="submit" className="h-11 w-full text-[15px]" disabled={loading} data-id="element-690" data-mp="3onhr5gemu9i0">
                {loading ? 'যাচাই করা হচ্ছে…' : 'লগইন করুন'}
              </Button>
            </form> : <div className="space-y-4" data-id="element-691" data-mp="1ua09ub4tm8vf">
              <div className="rounded-md border border-[#1769AA]/25 bg-[#E8F1FA] p-3 text-sm text-[#0f4c80]" data-id="element-692" data-mp="1ub1mgk1hj3f9">
                <div className="flex items-center gap-2 font-semibold" data-id="element-693" data-mp="9t96y94zetvi"><KeyRound className="h-4 w-4" data-id="element-694" data-mp="eqixjs43xbkx" /> দ্বি-স্তর যাচাই (MFA)</div>
                <p className="mt-1" data-id="element-695" data-mp="z48b3jlwe5f">{roleLabel(pending.role)} রোলের জন্য নিবন্ধিত মোবাইলে (০১৭১১-****৪২) পাঠানো ৬ অঙ্কের OTP প্রদান করুন।</p>
              </div>
              <Input value={otp} onChange={e => {
            setOtp(e.target.value.replace(/\D/g, '').slice(0, 6));
            setOtpError('');
          }} inputMode="numeric" placeholder="৬ অঙ্কের OTP" className="h-12 text-center font-mono text-xl tracking-[0.5em]" aria-label="OTP কোড" data-id="element-696" data-mp="4ymxwcmdhdel" />
              {otpError && <p className="text-xs text-[#D93036]" data-id="element-697" data-mp="3e6pjo544mhif">{otpError}</p>}
              <p className="text-xs text-slate-500" data-id="element-698" data-mp="3i6g65wmmebh5">ডেমো: যেকোনো ৬ অঙ্ক (যেমন 123456) ব্যবহার করুন।</p>
              <Button className="h-11 w-full" onClick={verifyOtp} data-id="element-699" data-mp="1cdhw68ed0tlg">যাচাই করে প্রবেশ করুন</Button>
              <button className="w-full text-sm text-slate-500 hover:underline" onClick={() => setPending(null)} data-id="element-700" data-mp="1gg4qqh2f0smc">ফিরে যান</button>
            </div>}

          <section className="mt-8 rounded-lg border border-dashed border-[#1769AA]/40 bg-[#F4F7FB] p-4" data-id="element-701" data-mp="48cb6lxmsb02">
            <div className="mb-2 text-xs font-semibold text-[#1769AA]" data-id="element-702" data-mp="3venfqs1untw5">রোল-ভিত্তিক ডেমো লগইন (পাসওয়ার্ড: demo@123)</div>
            <div className="grid gap-1.5" data-id="element-703" data-mp="3ln0yadyx4yky">
              {demoUsers.map(u => <button key={u.userId} type="button" onClick={() => fill(u)} className={`flex items-center justify-between rounded-md px-3 py-2 text-left text-[13px] hover:bg-white ${userId === u.userId ? 'bg-white ring-1 ring-[#1769AA]' : ''}`} data-id="element-704" data-mp="3lkwurx4xm1l7">
                  <span data-id="element-705" data-mp="37o1831vrcbmo">
                    <span className="font-semibold text-slate-800" data-id="element-706" data-mp="37n8cmx2918ju">{u.name}</span>
                    <span className="block text-[11.5px] text-slate-500" data-id="element-707" data-mp="32p6rm6l9iz5q">{u.title}, {u.dept}</span>
                  </span>
                  <span className="ml-2 shrink-0 rounded bg-[#003B71]/10 px-2 py-0.5 text-[11px] text-[#003B71]" data-id="element-708" data-mp="15uttxvrvs02d">{roleLabel(u.role)}</span>
                </button>)}
            </div>
          </section>
        </div>
      </main>

      <Dialog open={forgotOpen} onOpenChange={setForgotOpen} data-id="element-709" data-mp="1demcohbz1etu">
        <DialogContent data-id="element-710" data-mp="1dd1g6m63jltc">
          <DialogHeader data-id="element-711" data-mp="1i64e16hwphfc">
            <DialogTitle data-id="element-712" data-mp="1i5kyfwfqb54h">পাসওয়ার্ড পুনরুদ্ধার</DialogTitle>
            <DialogDescription data-id="element-713" data-mp="1i874tsqvvel4">আপনার ইউজার আইডি প্রদান করুন। নিবন্ধিত সরকারি ইমেইল ও মোবাইলে রিসেট লিংক পাঠানো হবে। প্রয়োজনে আইসিটি বিভাগে যোগাযোগ করুন।</DialogDescription>
          </DialogHeader>
          <div className="px-6 pb-4" data-id="element-714" data-mp="qh1a5rtxm938">
            <Input placeholder="ইউজার আইডি" defaultValue={userId} data-id="element-715" data-mp="ufi8pmzaeb91" />
          </div>
          <DialogFooter data-id="element-716" data-mp="zetqmzbe3ms7">
            <Button variant="outline" onClick={() => setForgotOpen(false)} data-id="element-717" data-mp="zebo5ky4wcbu">বাতিল</Button>
            <Button onClick={() => {
            setForgotOpen(false);
            toast.success('রিসেট নির্দেশনা নিবন্ধিত মোবাইলে পাঠানো হয়েছে');
          }} data-id="element-718" data-mp="14eprwqspd042">রিসেট লিংক পাঠান</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>;
}